export default __webpack_public_path__ + "static/media/hard_skill_legos.11b2e516.svg";